import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
 
@Injectable({
  providedIn: 'root'
})
export class LoadingStateService {
  public loading$ = new BehaviorSubject<boolean>(false);
}